import type { HighlightInfo } from '@constants/types'
import type { Coordinates } from '@containers/admin/types'
import { asArray } from '@shared_utils/array_utils'
import type { LatLngLiteral } from 'leaflet'
import { v4 } from 'uuid'

function latLngToGpxString (latLng: LatLngLiteral) {
  return `<trkpt lat="${latLng.lat}" lon="${latLng.lng}">
    <ele>0.0</ele>
  </trkpt>`
}

function highlightToGpxString (waypoint: HighlightInfo) {
  return `<wpt lat="${waypoint.poiLat}" lon="${waypoint.poiLng}">
    <time>${waypoint.date}</time>
    <name>${encodeURIComponent(waypoint.poiTitle || '')}</name>
    <desc>${encodeURIComponent(waypoint.poiText || '')}</desc>
    <poiId>${waypoint.poiId}</poiId>
    <uuid>${waypoint.uuid || v4()}</uuid>
  </wpt>`
}

export function waypointInfoFromGpxElement (waypoint: Element): HighlightInfo {
  const poiId = waypoint.getElementsByTagName('poiId')[0]?.textContent ?? '0'
  const poiTitle = waypoint.getElementsByTagName('name')[0]?.textContent ?? ''
  const poiText = waypoint.getElementsByTagName('desc')[0]?.textContent ?? ''
  const lat = waypoint.getAttribute('lat') ?? '0'
  const lng = waypoint.getAttribute('lon') ?? '0'
  const ds = waypoint.getElementsByTagName('time')[0]?.textContent ?? '0'

  return {
    poiId,
    poiTitle: decodeURIComponent(poiTitle),
    poiText: decodeURIComponent(poiText),
    img: [],
    poiLat: parseFloat(lat),
    poiLng: parseFloat(lng),
    date: parseInt(ds) || 0
  }
}

export function createGpx (name: string, coordinates: Coordinates[], highlights?: HighlightInfo[]): string {
  return `<?xml version="1.0" encoding="UTF-8"?>
<gpx xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" 
xmlns="https://www.topografix.com/GPX/1/1" xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd http://www.garmin.com/xmlschemas/GpxExtensions/v3 http://www.garmin.com/xmlschemas/GpxExtensionsv3.xsd http://www.garmin.com/xmlschemas/TrackPointExtension/v1 http://www.garmin.com/xmlschemas/TrackPointExtensionv1.xsd" xmlns:gpxtpx="http://www.garmin.com/xmlschemas/TrackPointExtension/v1" xmlns:gpxx="http://www.garmin.com/xmlschemas/GpxExtensions/v3" version="1.1" creator="https://gpxstudio.github.io">
<metadata>
  <name>${name}</name>
  <type>Sailing</type>
  ${asArray(highlights).map(highlightToGpxString).join('')}
</metadata>
<trk>
  <trkseg>${coordinates.map(({ elements }) => elements.map(latLngToGpxString).join('')).join('')}
  </trkseg>
</trk>
</gpx>`
}
